import React from "react";

function Header() {
    return <header className="header">
        <img src="/icons/nibyou_big.svg" alt="Nibyou Logo" />
    </header>
}

export default Header;